export const shadowRoots = new WeakMap;
